import { IconGeoTag, Text } from '@direct-frontend/components';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries -- Нужно поправить
import { SelfPickUpPicker } from '@/features/SelfPickUpPicker';
import { type OrderDto } from '@/shared/api/order';
import { Trigger, type TriggerProps } from '@/shared/components/Trigger';
import { reinitializeOrderForm } from '../../lib/reinitializeOrderForm';
import { type SelfPickUpAddressFieldValue } from '../../model/forms/fieldSelfPickUpAddress';

type SelfPickUpAddressInputProps = TriggerProps & {
    order: OrderDto;
    storeSlug: string;
    defaultLocation: string;
    value?: SelfPickUpAddressFieldValue;
    onChange?: (address: SelfPickUpAddressFieldValue) => void;
    validationState?: 'valid' | 'invalid';
};

export const SelfPickUpAddressInput = (props: SelfPickUpAddressInputProps) => {
    const { order, storeSlug, value, defaultLocation, onChange, ...other } = props;

    return (
        <SelfPickUpPicker
            value={value}
            defaultLocation={defaultLocation}
            order={order}
            reinitializeOrderForm={reinitializeOrderForm}
            storeSlug={storeSlug}
            onChange={onChange}
        >
            {({ onOpenModal }) => (
                <Trigger {...other} iconLeft={<IconGeoTag size="24" />} onClick={onOpenModal}>
                    <Text size="mc">{value?.address || ''}</Text>
                </Trigger>
            )}
        </SelfPickUpPicker>
    );
};
